<template>
  <PlatformLayout :useOverlay="overlay">
    <v-container fluid>
      <xlsx-read :file="file">
        <xlsx-json @parsed="imported"></xlsx-json>
      </xlsx-read>
      <h2 class="text-center">Importación de productos de panel ternium</h2>
      <v-row>
        <v-col cols="4" offset="4">
          <v-file-input
            :rules="rules"
            accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
            placeholder="Selecciona tu archivo excel"
            label="Archivo a importar"
            show-size
            @change="onChange"
          ></v-file-input>
        </v-col>
        <v-col cols="10" class="mx-auto" v-if="productosImport.length > 0">
          <h3>Productos a importar</h3>
          <br />
          <v-alert color="blue" type="info">
            El aceptar esta importación implicará borrar definitivamente todos
            los registros actuales de productos de panel ternium para dar de
            alta los pertenecientes a esta lista.
          </v-alert>
        </v-col>
      </v-row>
      <v-row v-if="productosImport.length > 0 && errores.length == 0">
        <v-col cols="12">
          <v-btn @click="uploadNewProducts">CARGAR NUEVO CATÁLOGO</v-btn>
        </v-col>
      </v-row>
      <v-row v-if="errores.length > 0">
        <v-col cols="10" class="mx-auto">
          <h3>Errores de formato</h3>
          <br />
          <v-alert color="red" type="error" class="text-center">
            <p class="text-subtitle-1 font-weight-bold">
              El formato proporcionado presenta los siguientes errores:
            </p>
            <p
              class="text-body-2"
              v-for="(error, index) of errores"
              :key="index"
            >
              {{ error }}
            </p>
          </v-alert>
        </v-col>
      </v-row>
      <v-row v-if="productosImport.length > 0">
        <v-col cols="10" class="mx-auto">
          <v-data-table
            :headers="headers"
            :items="productosImport"
            :items-per-page="-1"
            class="elevation-3"
            :footer-props="{
              itemsPerPageText: 'El. por página',
              itemsPerPageAllText: 'Todo',
              itemsPerPageOptions: ippoptions,
            }"
            no-data-text="No hay datos para mostrar"
          >
            <template v-slot:[`item.peso_por_unidad`]="{ item }">
              <div>{{ item.peso_por_unidad || "N/A" | number }}</div>
            </template>
            <template v-slot:[`item.precio_lista`]="{ item }">
              <div>{{ item.precio_lista || 0 | currency }}</div>
            </template>
            <template v-slot:[`item.precio_unitario`]="{ item }">
              <div>{{ item.precio_unitario || 0 | currency }}</div>
            </template>
            <template v-slot:[`item.st_costo`]="{ item }">
              <div>{{ item.st_costo || 0 | currency }}</div>
            </template>
          </v-data-table>
        </v-col>
      </v-row>
    </v-container>
  </PlatformLayout>
</template>

<script>
import PlatformLayout from "../components/PlatformLayout.vue";
import { XlsxRead, XlsxJson } from "vue-xlsx";
import { httpPost } from "@/services/apiService";
import { httpGet } from "../services/apiService";
import { fakeText } from "@/helpers/fakeText";

export default {
  name: "ImportacionProducto",
  components: {
    PlatformLayout,
    XlsxRead,
    XlsxJson,
  },
  data() {
    return {
      file: null,
      productosImport: [],
      rules: [
        (value) =>
          !value ||
          value.size < 20000000 ||
          "El archivo no puede ser mayor que 20 MB.",
      ],
      headers: [
        {
          text: "Código",
          align: "center",
          sortable: false,
          value: "codigo",
        },
        {
          text: "Descripción",
          align: "center",
          sortable: false,
          value: "descripcion",
        },
        {
          text: "F-KG",
          align: "center",
          sortable: false,
          value: "factores.kilogramo.valor",
        },
        {
          text: "F-M2",
          align: "center",
          sortable: false,
          value: "factores.metro_cuadrado.valor",
        },
        {
          text: "Precio de lista",
          align: "center",
          sortable: false,
          value: "precio_lista",
        },
      ],
      ippoptions: [-1],
      errores: [],
      overlay: false,
    };
  },
  methods: {
    onChange(event) {
      this.file = event;
    },
    async imported(event) {
      this.overlay = true;

      if (!this.file) {
        this.overlay = false;
        this.$toasted.show(
          "No se ha podido detectar formato adecuado en el archivo, revisarlo",
          {
            type: "error",
          }
        );
        return;
      }

      const { data } = await httpGet("/grosores");

      for (let item of event) {
        const grosores = data?.data
          ?.filter((t) => t?.attributes?.grosor == item["GROSOR (PULGADAS)"])
          .map((t) => t.id);

        this.productosImport.push({
          codigo: item["CODIGO"],
          descripcion: item["DESCRIPCION O PRODUCTO GENERICO"],
          precio_lista: item["PRECIO DE LISTA"] || 0,
          familia: "panel_ternium",
          factores: {
            unidad: {
              activo: item["VENTA X PZA"] ?? false,
              referencia: item["UNIDAD"] ?? "PZA",
              peso_por_unidad: item["PESO X UNIDAD"] ?? null,
              valor: 1,
            },
            metro_lineal: {
              activo: item["VENTA X ML"] ?? false,
              referencia: "ML",
              peso_por_unidad: item["PESO X UNIDAD"] ?? null,
              valor: 1,
            },
            kilogramo: {
              activo: item["VENTA X KG"] ?? false,
              referencia: "KG",
              peso_por_unidad: 1,
              valor: item["FKG"] ?? 1,
            },
            metro_cuadrado: {
              activo: item["VENTA X M2"] ?? false,
              referencia: "M2",
              peso_por_unidad: item["PESO X M2"] ?? null,
              valor: item["FM2 (AE)"] ?? 1,
            },
          },
          grosores,
          tipo_panel: item["TIPO PANEL"]?.toLowerCase(),
          observaciones: item["OBSERVACIONES"] ?? null
        });
      }

      (this.productosImport);

      const { hasErrors, err } = this.validateEntries(this.productosImport);

      if (hasErrors == true) {
        this.errores = err;
        console.warn("errores de importacion: ", err);
        this.overlay = false;
        return;
      }

      this.overlay = false;
    },
    validateEntries(lista) {
      let err = [];
      let hasErrors = false;
      for (const l of lista) {
        if (l.precio_lista < 0 || typeof l.precio_lista != "number") {
          hasErrors = true;
          err.push(
            `El precio de lista del producto ${l.descripcion} es negativo.`
          );
        }

        if (l.grosores.length == 0 || !l.grosores) {
          hasErrors = true;
          err.push(`El producto ${l.descripcion} no tiene un grosor definido.`);
        }

        if (!l.tipo_panel) {
          hasErrors = true;
          err.push(
            `El producto ${l.descripcion} no tiene un tipo definido. Use MURO o TECHO en la columna TIPO PANEL.`
          );
        }

        if (typeof l.codigo == "number") {
          l.codigo = l.codigo.toString();
        }
      }

      return {
        hasErrors,
        err,
      };
    },
    async uploadNewProducts() {
      this.overlay = true;

      const { data } = await httpPost("/productos/bulk-upload", {
        data: { products: this.productosImport, family: "panel_ternium" },
      }).catch((err) => {
        this.$toasted.show(
          "Ha ocurrido un error, no se puede cargar el formato, hable a soporte",
          {
            type: "error",
          }
        );
        this.overlay = false;
      });

      this.$toasted.show(data?.message, {
        type: "success",
      });

      this.productosImport = [];
      this.overlay = false;
      this.$router.push({ path: "/platform/productos" });
    },
  },
};
</script>
